export class SiterecordIntersections {
  public id: number;
  public siterecordId: number;
  public intersectionsOrder: number;
  public maxLineupLengthAvailable: number;
  public trafficlightSignalGroup: string;
  public trafficSortingCharacteristics: string; // TrafficSortingCharacteristicsType
}



// WEBPACK FOOTER //
// ./src/app/models/siterecordintersections.model.ts